import React, { useState, useEffect } from 'react';
import './Card.css';

const Card = ({
  onNewDossier,
  onSuperviseDossier,
  showOrganisation = false,
  organisations = [],
  organisationId = '',
  onOrganisationChange = () => {},
  organisationsError = false,
}) => {
  const getCodeFromURL = () => {
    const segments = window.location.pathname.split('/');
    const lastSegment = segments[segments.length - 1];
    return lastSegment !== 'test-apis' ? lastSegment : '';
  };

  const [code, setCode] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const urlCode = getCodeFromURL();
    if (urlCode) {
      setCode(urlCode);
    }
  }, []);

  const handleNewDossierSubmit = () => {
    if (code) {
      onNewDossier(code);
    } else {
      showError('Veuillez entrer un code valide.');
    }
  };

  const showError = (message) => {
    setErrorMessage(message);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const canSubmit = code.trim() && (!showOrganisation || organisationId);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleNewDossierSubmit();
  };

  useEffect(() => {
    if (!showPopup) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') closePopup(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [showPopup]);

  return (
    <div className="dossier-main-wrapper">
      <div className="dossier-content-area">
        <div className="content-header-section">
          <div className="main-icon-wrapper" aria-hidden="true">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14,2 14,8 20,8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10,9 9,9 8,9"></polyline>
            </svg>
          </div>
          <h2 className="section-main-title">Analyser en temps réel</h2>
          <p className="section-description">Traitez un nouveau dossier en entrant le code correspondant</p>
        </div>

        <form className="form-inputs-section" onSubmit={handleSubmit} noValidate>
          <div className="field-group">
            <label htmlFor="code" className="field-label">Code du dossier</label>
            <div className="input-field-wrapper">
              <svg className="field-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
              </svg>
              <input
                type="text"
                id="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Entrez le code du dossier"
                className="custom-input-field"
                autoComplete="off"
                autoFocus
              />
            </div>
          </div>

          {showOrganisation && (
            <div className="field-group">
              <label htmlFor="organisation" className="field-label">
                Organisation du dossier <span className="field-required" aria-hidden="true">*</span>
              </label>
              <div className="input-field-wrapper">
                <select
                  id="organisation"
                  value={organisationId}
                  onChange={(e) => onOrganisationChange(e.target.value)}
                  className="custom-input-field custom-select-field"
                  required
                >
                  <option value="">
                    {organisationsError
                      ? 'Impossible de charger les organisations'
                      : organisations.length === 0
                        ? 'Aucune organisation cliente active'
                        : "Choisir l'organisation..."}
                  </option>
                  {organisations.map((org) => (
                    <option key={org.id} value={String(org.id)}>{org.name}</option>
                  ))}
                </select>
              </div>
              {organisationsError && (
                <span className="field-hint field-hint-error">Rechargez la page pour réessayer.</span>
              )}
            </div>
          )}

          <button type="submit" className="action-primary-btn" disabled={!canSubmit}>
            <span>Lancer l'analyse</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12,5 19,12 12,19"></polyline>
            </svg>
          </button>
        </form>
      </div>

      {showPopup && (
        <div className="modal-overlay-layer" onMouseDown={(e) => { if (e.target === e.currentTarget) closePopup(); }}>
          <div className="alert-modal-box" role="alertdialog" aria-modal="true" aria-labelledby="card-alert-title">
            <div className="modal-icon-container" aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <h3 className="modal-title" id="card-alert-title">Information</h3>
            <p className="modal-message">{errorMessage}</p>
            <button onClick={closePopup} className="modal-confirm-btn" autoFocus>
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;